const initGgm = (gtmId: string) => {
  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  // @ts-ignore
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  // @ts-ignore
  window.gtag = function gtag() {
    // @ts-ignore
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };

  const script = document.createElement('script');

  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

  document.head.appendChild(script);

  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');

  Object.assign(iframe.style, { display: 'none', visibility: 'hidden' });
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  noscript.appendChild(iframe);

  document.body.appendChild(noscript);
};

export default initGgm;
